import { SVGProps } from 'react';

export const BillingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0001 8.16758H9.66672V6.50091H13.0001V8.16758ZM13.0001 11.5009H9.66672V9.83425H13.0001V11.5009ZM13 14.8334H3.8333V13.1668H13V14.8334ZM2.99991 9.00008H5.91658C6.14575 9.00008 6.33325 8.81342 6.33325 8.58342C6.33325 8.35425 6.14575 8.16675 5.91658 8.16675H5.08325C3.93408 8.16675 2.99991 7.23175 2.99991 6.08342C2.99991 5.07758 3.71658 4.23592 4.66658 4.04258V3.16675H6.33325V4.00008H7.99991V5.66675H5.08325C4.85325 5.66675 4.66658 5.85425 4.66658 6.08342C4.66658 6.31342 4.85325 6.50008 5.08325 6.50008H5.91658C7.06491 6.50008 7.99991 7.43508 7.99991 8.58342C7.99991 9.58925 7.28241 10.4318 6.33325 10.6251V11.5001H4.66658V10.6668H2.99991V9.00008ZM15.2558 5.07758L11.0892 0.910915C10.9333 0.754248 10.7208 0.666748 10.5 0.666748H1.33333C0.873333 0.666748 0.5 1.04008 0.5 1.50008V16.5001C0.5 16.9609 0.873333 17.3334 1.33333 17.3334H14.6667C15.1267 17.3334 15.5 16.9609 15.5 16.5001V5.66675C15.5 5.44591 15.4125 5.23342 15.2558 5.07758Z"
        fill="currentColor"
      />
    </svg>
  );
};
